import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { ResponseSendSMSVerificationPresenter } from "../profile/profileServiceInterface/phoneLoginInterface";
import type { RequestVerifyOptInterfaceInterface } from "../profile/profileServiceInterface/verifyOptInterface";
import { ResponseProvinceRegisterListInterface } from "./rewardServiceInterface/getProvinceRegisterListInterface";
import { ResponseRewardSurveyInterface } from "./rewardServiceInterface/getRewardSurveyInterface";
import { ResponseRewardRegisterCheckOtp } from "./rewardServiceInterface/postRewardRegisterCheckOtpInterface";
import type { RequestRewardRegisterInterface } from "./rewardServiceInterface/postRewardRegisterInterface";

class RewardServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "reward";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getProvinceRegisterList() {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `v2/${this.basePath}/register`,
        "GET",
      )) as any;
      return new ResponseProvinceRegisterListInterface(response);
    } catch {
      return new ResponseProvinceRegisterListInterface({});
    }
  }

  async getRewardSurveyList(): Promise<ResponseRewardSurveyInterface> {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/survey`,
      "GET",
    )) as any;

    return new ResponseRewardSurveyInterface(response);
  }

  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************
  async postRewardRegister(params: RequestRewardRegisterInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/register`,
      "POST",
      params,
    )) as any;

    return new ResponseSendSMSVerificationPresenter(response);
  }

  async postRewardRegisterCheckOtp(body: RequestVerifyOptInterfaceInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/register/checkOtp`,
      "POST",
      body,
    )) as any;

    return new ResponseRewardRegisterCheckOtp(response);
  }

  async postSurvey(body: any) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/survey`,
      "POST",
      body,
    )) as any;

    return new ResponseRewardSurveyInterface(response);
  }
}
export default RewardServiceApi;
